// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"Checkbox_checkboxContainer__YzbUC"};